document.addEventListener("DOMContentLoaded", () => {
  const openAccordion = (accordion) => {
    const content = accordion.querySelector(".zone_content");
    if (!content) return;
    accordion.classList.add("active");
    content.style.maxHeight = content.scrollHeight + "px";
  };

  const closeAccordion = (accordion) => {
    const content = accordion.querySelector(".zone_content");
    if (!content) return;
    accordion.classList.remove("active");
    content.style.maxHeight = null;
  };

  // Attach click listeners only to valid zones
  document.querySelectorAll(".zone").forEach((accordion) => {
    const intro = accordion.querySelector(".zone_title");
    const content = accordion.querySelector(".zone_content");
    if (!intro || !content) return;

    intro.onclick = () => {
      if (content.style.maxHeight) {
        closeAccordion(accordion);
      } else {
        const parent = accordion.closest(".private-car");
        if (!parent) return;
        parent
          .querySelectorAll(".zone")
          .forEach((sibling) => closeAccordion(sibling));
        openAccordion(accordion);
      }
    };
  });

  // Open Zone 1 by default in every private-car
  document.querySelectorAll(".private-car").forEach((car) => {
    const firstZone = car.querySelector(".zone_1");
    if (firstZone && !firstZone.classList.contains("active")) {
      openAccordion(firstZone);
    }
  });
});
